// Config and trix before-initialize listeners set up specifically for Goal Editor
import { goalsTrixInitialize } from '../goals-editor';

const GoalEditorSetup = (trix) => {
  // Create callbacks
  document.addEventListener('trix-initialize', goalsTrixInitialize);

  trix.default.config.textAttributes['gc-who'] = {
    tagName: 'gc-who',
  };
  trix.default.config.textAttributes['gc-skill'] = {
    tagName: 'gc-skill',
  };
  trix.default.config.textAttributes['gc-context'] = {
    tagName: 'gc-context',
  };
  trix.default.config.textAttributes['gc-measurable'] = {
    tagName: 'gc-measurable',
  };
  trix.default.config.textAttributes['gc-reason'] = {
    tagName: 'gc-reason',
  };
  trix.default.config.textAttributes['gc-timeframe'] = {
    tagName: 'gc-timeframe',
  };
};

export default GoalEditorSetup;
